module.exports = __webpack_public_path__ + "static/media/cow.92092f02.jpg";